// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { getErrorMessage } from "../../../components/src/CommonFunctions";

export const configJSON = require("./config");

const staticTemplate = {
  id: "7",
  type: "automations",
  attributes: {
    id: 7,
    name: "Third automation new",
    business_name: null,
    trigger_condition: "When user loggin",
    action_type: "send email",
    message_template: {
      content:
        "Thank you for sign up our team will get back to you as soon as possible",
      subject: "new user sign up message",
    },
  },
};

export interface Props {
  navigation: any;
  id: string;
  classes: any
}

interface S {
  defaultautomations: any;
  userautomtions:any,
  displayItem:number,
  isModalOpen: boolean;
  loading: boolean;
  selectedTemplate: any;
  showAlert: boolean;
  alertMsg: string;
  isdefaultAutomation: boolean;
  currentTemplatePage: number;
  isCreateModalOpen: boolean;
  newTemplateTitle: string;
  newTemplateMessage: string;
  isEditMode: boolean;
  modalKey: number;
  message:any;
}
interface SS {
  id: any;
}
export default class AutomationController extends BlockComponent<Props, S, SS> {
  getAutomationTemplatesApiId: any = "";
  updateAutomationTemplateApiId: any = "";
  deleteAutomationTemplateApiId: any = "";
  createAutomationTemplateApiId: any = "";

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];

    this.state = {
      defaultautomations: [],
      userautomtions:[],
      displayItem: 6,
      isModalOpen: false,
      loading: false,
      selectedTemplate: staticTemplate,
      showAlert: false,
      alertMsg: "",
      isdefaultAutomation: false,
      currentTemplatePage: 0,
      isCreateModalOpen: false,
      newTemplateTitle: "",
      newTemplateMessage: "",
      isEditMode: false,
      modalKey: 0,
      message:''
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  handleClose = () => {
    this.setState({ isModalOpen: false, isEditMode: false });
  }

  openModal(data: any) {
    console.log("🔵 Opening modal with template data:", data);
    console.log("🔵 Message template:", data?.attributes?.message_template);
    console.log("🔵 Content:", data?.attributes?.message_template?.content);
    
    // Always find the latest version of the template from the current lists
    // This ensures we have the most up-to-date data even if the list was refreshed
    const allTemplates = [
      ...this.state.defaultautomations,
      ...this.state.userautomtions
    ];
    let latestTemplate = allTemplates.find(
      (template: any) => template.id === data.id
    ) || data;
    
    console.log("🔵 Found template from lists:", latestTemplate);
    console.log("🔵 Template from lists - message_template:", latestTemplate?.attributes?.message_template);
    
    // CRITICAL: Always prefer selectedTemplate if it exists and has the same ID
    // This ensures we show the most recently saved data
    if (this.state.selectedTemplate && this.state.selectedTemplate.id === data.id) {
      console.log("🔵 selectedTemplate exists with same ID:", this.state.selectedTemplate);
      console.log("🔵 selectedTemplate message_template:", this.state.selectedTemplate.attributes?.message_template);
      
      // Always use selectedTemplate if it has message_template (it was recently updated)
      const selectedHasMessageTemplate = this.state.selectedTemplate.attributes?.message_template;
      if (selectedHasMessageTemplate && selectedHasMessageTemplate.content) {
        console.log("🔵 Using selectedTemplate (has saved message)");
        latestTemplate = this.state.selectedTemplate;
      } else {
        // If selectedTemplate doesn't have message_template but latestTemplate does, use latestTemplate
        const latestHasMessageTemplate = latestTemplate.attributes?.message_template;
        if (latestHasMessageTemplate && latestHasMessageTemplate.content) {
          console.log("🔵 Using latestTemplate from lists (has message)");
        } else {
          // Fallback to selectedTemplate
          console.log("🔵 Using selectedTemplate (fallback)");
          latestTemplate = this.state.selectedTemplate;
        }
      }
    }
    
    console.log("🔵 Final template to use:", latestTemplate);
    console.log("🔵 Final message_template:", latestTemplate?.attributes?.message_template);
    
    // Reset edit mode and set the selected template
    // Increment modalKey to force form reinitialization
    this.setState((prevState: any) => ({ 
      isModalOpen: true, 
      selectedTemplate: latestTemplate, 
      isEditMode: false,
      modalKey: prevState.modalKey + 1
    }));
  }
  
  setAutomation(val: boolean) {
    this.setState({ isdefaultAutomation: val })
  }
  
  toggleEditMode = () => {
    this.setState({ isEditMode: !this.state.isEditMode });
  }

  async receive(from: string, message: Message) {
    const messageType = getName(MessageEnum.RestAPIResponceMessage);

    if (messageType === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (responseJson.data) {
        this.setState({ loading: false });
        if (apiRequestCallId === this.getAutomationTemplatesApiId) {          
          this.setState({ defaultautomations: responseJson.data.default_automations.data });
          this.setState({ userautomtions: responseJson.data.user_automations.data });
          
          // Always update selectedTemplate if it exists, even if modal is closed
          // This ensures the updated data is available when modal is reopened
          if (this.state.selectedTemplate) {
            const allTemplates = [
              ...responseJson.data.default_automations.data,
              ...responseJson.data.user_automations.data
            ];
            const updatedTemplate = allTemplates.find(
              (template: any) => template.id === this.state.selectedTemplate.id
            );
            if (updatedTemplate) {
              this.setState({
                selectedTemplate: updatedTemplate,
                modalKey: this.state.modalKey + 1
              });
            }
          }
        }

        if (apiRequestCallId === this.updateAutomationTemplateApiId) {
          // DEBUG: Print raw API response to see the actual structure
          console.log("🔍 Raw API Response (updateAutomationTemplateApiId):", JSON.stringify(responseJson, null, 2));
          console.log("🔍 responseJson.data:", responseJson.data);
          console.log("🔍 responseJson.data?.data:", responseJson.data?.data);
          console.log("🔍 responseJson.data?.automation:", responseJson.data?.automation);
          
          // Safely access the response data - check multiple possible structures
          let updatedTemplate = null;
          
          // Try different possible response structures
          if (responseJson?.data?.data) {
            updatedTemplate = responseJson.data.data;
          } else if (responseJson?.data?.automation) {
            updatedTemplate = responseJson.data.automation;
          } else if (responseJson?.data) {
            updatedTemplate = responseJson.data;
          } else if (responseJson?.automation) {
            updatedTemplate = responseJson.automation;
          } else if (responseJson) {
            // If responseJson itself is the template
            updatedTemplate = responseJson;
          }
          
          console.log("🔍 Extracted updatedTemplate:", updatedTemplate);
          
          if (updatedTemplate && this.state.selectedTemplate) {
            // Safely extract message_template from various possible structures
            let responseMessageTemplate = null;
            
            if (updatedTemplate.attributes?.message_template) {
              responseMessageTemplate = updatedTemplate.attributes.message_template;
            } else if (updatedTemplate.message_template) {
              responseMessageTemplate = updatedTemplate.message_template;
            } else if (updatedTemplate.attributes?.subject || updatedTemplate.attributes?.content) {
              responseMessageTemplate = {
                subject: updatedTemplate.attributes.subject || "",
                content: updatedTemplate.attributes.content || ""
              };
            } else if (updatedTemplate.subject || updatedTemplate.content) {
              responseMessageTemplate = {
                subject: updatedTemplate.subject || "",
                content: updatedTemplate.content || ""
              };
            }
            
            console.log("🔍 Extracted message_template:", responseMessageTemplate);
            
            // Build the template structure safely
            // IMPORTANT: Preserve existing attributes but prioritize API response data
            const templateToUpdate = {
              ...updatedTemplate,
              id: updatedTemplate.id || updatedTemplate.attributes?.id || this.state.selectedTemplate.id,
              attributes: {
                // Start with existing attributes to preserve structure
                ...(this.state.selectedTemplate.attributes || {}),
                // Override with API response attributes
                ...(updatedTemplate.attributes || {}),
                // CRITICAL: Ensure message_template is properly set from API response
                // If API response has message_template, use it; otherwise keep existing
                message_template: responseMessageTemplate || this.state.selectedTemplate.attributes?.message_template || {
                  subject: updatedTemplate.attributes?.subject || this.state.selectedTemplate.attributes?.message_template?.subject || "",
                  content: updatedTemplate.attributes?.content || this.state.selectedTemplate.attributes?.message_template?.content || ""
                }
              }
            };
            
            console.log("🔍 Final templateToUpdate:", templateToUpdate);
            
            // CRITICAL: Update selectedTemplate with the API response data BEFORE closing modal
            // This ensures the saved message is preserved in state even after modal closes
            this.setState({
              selectedTemplate: templateToUpdate,
              modalKey: this.state.modalKey + 1 // Force Formik to reinitialize with new data
            });
          } else {
            console.warn("⚠️ Could not extract updatedTemplate from API response");
            console.warn("⚠️ responseJson:", responseJson);
            console.warn("⚠️ selectedTemplate:", this.state.selectedTemplate);
          }
          
          // Close modal after state is updated
          this.setState({
            isModalOpen: false,
            isEditMode: false,
            alertMsg: "Template updated successfully! ",
            showAlert: true,
          });
          
          // Refresh templates list to ensure consistency
          // This will also update selectedTemplate when response comes back
          this.getTemplates();
          
          setTimeout(() => {
            this.setState({showAlert:false})
          },2000)
        }

        if (apiRequestCallId === this.deleteAutomationTemplateApiId) {
          this.setState({
            isModalOpen: false,
            alertMsg: "Template deleted successfully!",
            showAlert: true,
          });
          this.getTemplates();
          setTimeout(() => {
            this.setState({ showAlert: false });
          }, 2000);
        }

        if (apiRequestCallId === this.createAutomationTemplateApiId) {
          this.setState({
            isCreateModalOpen: false,
            newTemplateTitle: "",
            newTemplateMessage: "",
            alertMsg: "Template created successfully!",
            showAlert: true,
          });
          this.getTemplates();
          setTimeout(() => {
            this.setState({ showAlert: false });
          }, 2000);
        }
      } else if (responseJson.errors) {
        this.setState({ 
          isModalOpen: false, 
          isCreateModalOpen: false,
          loading: false 
        });
        const err = getErrorMessage(responseJson.errors[0]);
        alert(err);
      }
    }
  }

  async componentDidMount(): Promise<void> {
    this.getTemplates();
  }

  getTemplates() {
    this.setState({ loading: true });
    const headerData = {
      "Content-Type": configJSON.contentType,
      token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getAutomationTemplatesApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.automationTemplatesApiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  onUpDateTemplate(value: any) {
    // For default automations in edit mode, update the name from the subject field
    // For user automations, use the existing name
    const templateName = this.state.isdefaultAutomation && this.state.isEditMode
      ? value.subject
      : this.state.selectedTemplate.attributes.name;
      const htmlToPlainText = (html:any) => {
        if (!html) return "";
        return html
          .replace(/<br\s*\/?>/gi, "\n")
          .replace(/<\/p>/gi, "\n\n")
          .replace(/<[^>]+>/g, "")
          .trim();
      };

    // IMMEDIATELY update selectedTemplate with the new values for instant UI feedback
    // This ensures the modal shows updated data even before API response
    if (this.state.selectedTemplate) {
      const updatedTemplate = {
        ...this.state.selectedTemplate,
        attributes: {
          ...this.state.selectedTemplate.attributes,
          name: templateName,
          message_template: {
            subject: value.subject,
            content: value.content,
          },
        },
      };
      
      this.setState({
        selectedTemplate: updatedTemplate,
        modalKey: this.state.modalKey + 1, // Force Formik to reinitialize
        message: htmlToPlainText(this.state.selectedTemplate?.attributes?.message_template)
      });
    }

    const httpBody = {
      automation: {
        name: templateName,
        trigger_condition:
          this.state.selectedTemplate.attributes.trigger_condition || value.subject,
        action_type: this.state.selectedTemplate.attributes.action_type || "send_message",
        message_template: {
          content: value.content,
          subject: value.subject,
        },
      },
    };

    const headerData = {
      "Content-Type": configJSON.contentType,
      token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.updateAutomationTemplateApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.automationTemplatesApiEndPoint +
        "/" +
        this.state.selectedTemplate.id
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "PUT"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  createAutomationTemplate = (title: string, message: string) => {
    const httpBody = {
      automation: {
        name: title,
        trigger_condition: title,
        action_type: "send_message",
        message_template: {
          content: message,
          subject: title,
        },
      },
    };

    const headerData = {
      "Content-Type": configJSON.contentType,
      token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.createAutomationTemplateApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.automationTemplatesApiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  deleteAutomationTemplate = (id: string | number) => {
    const headerData = {
      "Content-Type": configJSON.contentType,
      token: localStorage.getItem("authToken"),
    };

    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.deleteAutomationTemplateApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.automationTemplatesApiEndPoint}/${id}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.deleteApiMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  updateSeemore() {
    const {defaultautomations, displayItem} = this.state;
    if (displayItem >= 20) {
      this.setState({
        showAlert: true,
        alertMsg: "You can only edit up to 20 automation templates.",
      });
      setTimeout(() => {
        this.setState({ showAlert: false });
      }, 2000);
    } else {
      this.setState({
        displayItem: Math.min(displayItem + 6, 20, defaultautomations.length)
      });
    }
  }
  updateAutomationActive(id: number, active: boolean) {
    const headerData = {
      "Content-Type": configJSON.contentType,
      token: localStorage.getItem("authToken"),
    };
    const httpBody = {
      automation: {
        is_active: active   
      }
    };
    // Log the payload to verify
    console.log('Payload:', JSON.stringify(httpBody));
  
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    
    this.updateAutomationTemplateApiId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.automationTemplatesApiEndPoint}/${id}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "PUT"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }
}
// Customizable Area End
